import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment/moment";

const matrix = [
  {
    type: "kwalifikacje_bazowe",
    translation: "Kwalifikacje Bazowe",
  },
  {
    type: "kwalifikacje_uzupelniajace",
    translation: "Kwalifikacje Uzupełniające",
  },
  {
    type: "jezyki_obce",
    translation: "Języki Obce",
  },
  {
    type: "kompetencje_it",
    translation: "Kompetencje IT",
  },
  {
    type: "kompetencje_spoleczne",
    translation: "Kompetencje Społeczne",
  },
  {
    type: "dzialalnosc_gospodarcza",
    translation: "Dzialalność Gospodarcza",
  },
  {
    type: "sekcja_doswiadczenie",
    translation: "Sekcja doświadczenie",
  },
  {
    type: "sekcja_dzialalnosc_gospodarcza",
    translation: "Sekcja dzialalność gospodarcza",
  },
  {
    type: "sekcja_jezyki",
    translation: "Sekcja języki",
  },
  {
    type: "sekcja_kompetencje_it",
    translation: "Sekcja kompetencje IT",
  },
  {
    type: "sekcja_kompetencje_spoleczne",
    translation: "Sekcja kompetencje społeczne",
  },
  {
    type: "sekcja_kursy",
    translation: "Sekcja kursy",
  },
  {
    type: "sekcja_kwalifikacje",
    translation: "Sekcja kwalifikacje",
  },
  {
    type: "sekcja_wyksztalcenie",
    translation: "Sekcja wykształcenie",
  },
  {
    type: "sekcja_zainteresowania",
    translation: "Sekcja zainteresowania",
  },
];

const SectionElement = ({ name, section, expanded, setExpanded }) => {
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  let calculatePercentage = (array) => {
    if (array) {
      const userBadges = array.filter((el) => el.owned).length;
      const allBadges = array.length;
      if (userBadges !== 0) {
        return (userBadges / allBadges) * 100;
      }
      return 0;
    }
  };

  const [progress, setProgress] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      setProgress(calculatePercentage(section));
    }, 150);
    // return () => {
    //   setProgress(0);
    // };
  }, [section]);

  return (
    <Accordion
      expanded={expanded === name}
      onChange={handleChange(name)}
      sx={{
        background: "rgba(255, 255, 255, 0.58)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        width: "100%",
        borderRadius: "7px",
        boxShadow:
          "0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 4px 10px 1px rgba(0, 0, 0, 0.14), 0px -3px 3px -3px rgba(0, 0, 0, 0.20)",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${name}-content`}
        id={`${name}-header`}
        sx={{
          position: "relative",
          overflow: "hidden",
          borderRadius: "7px",
          padding: 0,

          "& .MuiAccordionSummary-content": {
            margin: 0,
            alignSelf: "stretch",
            alignItems: "stretch",
            position: "relative",
            zIndex: 1,
            minWidth: 0,
          },

          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },

          "& .MuiAccordionSummary-expandIconWrapper": {
            position: "absolute",
            right: 16,
            zIndex: 2,
            color: "#1a1a1a",
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            borderRadius: "50%",
          },

          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: `${progress || 0}%`,
            height: "100%",
            backgroundColor: "#294e6b",
            transition: "width 1s ease",
            pointerEvents: "none",
            zIndex: 0,
          },
        }}
      >
        <Typography
          component="span"
          sx={{
            width: "100%",
            boxSizing: "border-box",
            padding: "12px 48px 12px 16px",
            display: "flex",
            alignItems: "center",

            backgroundColor: "#1a1a1a",

            backgroundImage: "linear-gradient(#ffffff, #ffffff)",
            backgroundRepeat: "no-repeat",
            backgroundSize: `${progress || 0}% 100%`,
            backgroundOrigin: "border-box",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            WebkitTextFillColor: "transparent",

            transition: "background-size 1s ease",
          }}
        >
          {matrix.find((item) => item.type === name)?.translation ?? name}
          {" | "}
          {Math.floor(calculatePercentage(section) || 0)}%
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List sx={{ width: "100%" }}>
          {section.map((element, i) => (
            <Link
              key={i}
              to={
                element.owned
                  ? `/odznaki/${element.id}`
                  : `/odznaki-do-odblokowania/${element.id}`
              }
              style={{ textDecoration: "none" }}
            >
              <ListItem sx={{ opacity: element.owned ? 1 : 0.3 }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      borderRadius: 0,
                      height: "46px",
                      backgroundColor: "rgb(235 244 250)",
                    }}
                  >
                    <img
                      src={element.image?.url}
                      alt={element.badgeName}
                      width="100%"
                    />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={element.badgeName}
                  secondary={
                    element.owned
                      ? moment(element.issuanceDate).format("LL")
                      : "Odznaka jeszcze nie odblokowana"
                  }
                />
              </ListItem>
            </Link>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};

export default SectionElement;
